import initialState from '../constants/initialState';
import * as types from '../constants/types';

export default (state = initialState.app, action) => {
	switch (action.type) {
		case types.app.LOADING:
			return {
				...state,
				loading: false,
			};
		case types.app.CHANGE_THEME:
			return {
				...state,
				theme: action.payload.theme,
			};
		case types.app.ERROR:
			return {
				...state,
				error: action.payload.error,
			};
		case types.app.NOT_FOUND:
			return {
				...state,
				notFound: true,
			};
		default:
			return state;
	}
};
